import React, { useEffect, useState } from 'react';
import CSS from 'csstype';
import { useSelector } from 'react-redux';
import { RootState } from 'app/main/rootReducer';
import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core';

const NS = 'DurationTable';

const useStyles = makeStyles({
  root: {
    '& .MuiTableCell-head': {
      fontWeight: 'bold'
    },
    '& .MuiTablePagination-toolbar': {
      minHeight: '48px'
    },
    width: '500px',
    marginTop: '10px'
  },
  container: {
    minHeight: '400px'
  },
  tableTitle: {
    fontWeight: 'normal',
    margin: '8px'
  }
});

/**
 * Displays the list of booking duration in tabular format
 */
export const DurationTable = () => {

  const rowsPerPage = 10;
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const { avgPerSpendDurationStats } = useSelector((state: RootState) => state.dashboardReducer);

  // Navigate to the first page, whenever data is refreshed.
  useEffect(() => setPage(0), [avgPerSpendDurationStats]);

  if (avgPerSpendDurationStats.length === 0) return null;

  const rows = avgPerSpendDurationStats.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((booking, index) => {
    return (
      <TableRow key={index}>
        <TableCell>Up to {booking.timeMinutes} minutes</TableCell>
        <TableCell>{booking.averageSpend && `$${(booking.averageSpend.toFixed(2))}`}</TableCell>
        <TableCell>{booking.averageSpendPerHead && `$${(booking.averageSpendPerHead.toFixed(2))}`}</TableCell>
        <TableCell>{booking.totalSpend && `$${(booking.totalSpend.toFixed(2))}`}</TableCell>
        <TableCell>{booking.bookingsTotal}</TableCell>
      </TableRow>
    );
  });

  return (
    <Paper id="durationTable" className={classes.root}>
      <h2 className={classes.tableTitle}>Duration of Booking x spend</h2>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell style={ColumnWidth}>Duration in Minutes</TableCell>
              <TableCell style={ColumnWidth}>Average Spend Per Booking</TableCell>
              <TableCell style={ColumnWidth}>Average Spend Per Head</TableCell>
              <TableCell style={ColumnWidth}>Total Spend</TableCell>
              <TableCell style={ColumnWidth}>Number of Bookings</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </TableContainer>
      {
        rows.length > 0 &&
        <TablePagination
          page={page}
          component="div"
          labelRowsPerPage=""
          rowsPerPageOptions={[]}
          rowsPerPage={rowsPerPage}
          count={avgPerSpendDurationStats.length}
          onChangePage={(event: unknown, newPage: number) => setPage(newPage)} />
      }
    </Paper>
  )
}

/** CSS styles */
const ColumnWidth: React.CSSProperties = { minWidth: '90' }
